import React from 'react';

import config from 'config';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { trackLoginPageView } from '~/login/actions';
import CloseButton from '~/shared/components/CloseButton';
import FableticsModal from '~/shared/components/FableticsModal';
import { AssetContainer } from '~/techstyle-shared/react-assets';
import {
  Button,
  Section,
  useBreakpoint,
} from '~/techstyle-shared/react-components';
import { defineMessages, useIntl } from '~/techstyle-shared/react-intl';
import { useSession } from '~/techstyle-shared/redux-core';

import LoginLabel from '../LoginLabel';
import LoginSlidingPanels from '../LoginSlidingPanels';

const LoginAsset = config.get('public.brand.loginModalBanner');

const defaults = defineMessages({
  title: {
    id: 'site_login.sign_in_title',
    defaultMessage: 'Sign In',
  },
});

const LoginButton = styled(Button).attrs({
  variant: 'unstyled',
})`
  font-size: inherit;
`;

const LoginAssetSection = styled(Section)`
  font-size: 14px;
  font-weight: 600;
  flex: 0 1 50%;
  display: flex;

  img {
    height: 100%;
    width: auto;
  }
`;

const Modal = styled(FableticsModal)`
  ${FableticsModal.ContentWrapper} {
    border-radius: 10px;
    overflow: hidden;
  }
`;

const ModalCloseButton = styled(CloseButton)`
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 18px;
`;

const LoginModal = ({ title, ...rest }) => {
  const intl = useIntl();
  const { isLoggedIn } = useSession();
  const { pathname } = useRouter();
  const { isMobile } = useBreakpoint();
  const dispatch = useDispatch();
  const homepageLoginSuccess = null;

  const onEnter = () => {
    const pageName = 'modal/login';
    dispatch(
      trackLoginPageView({
        pageName,
        name: pageName,
      })
    );
  };

  if (pathname === '/login' || isLoggedIn) {
    return null;
  }

  return (
    <Modal
      title={title || intl.formatMessage(defaults.title)}
      trigger={
        <LoginButton data-autotag="login_modal_signin">
          <LoginLabel />
        </LoginButton>
      }
      closeButton={<ModalCloseButton />}
      defaultOpen={false}
      showCloseButton
      dialogStyle="padding: 0; max-width:100%; width: 980px; scale(1, 1)"
      transitionEnter={{ opacity: 1, transform: 'scale(1, 1)' }}
      transitionFrom={{ opacity: 0, transform: 'scale(0.5, 0.5)' }}
      transitionLeave={{ opacity: 0, transform: 'scale(0.5, 0.5)' }}
      onEnter={onEnter}
      {...rest}
    >
      {!isMobile && (
        <LoginAssetSection>
          <AssetContainer
            background
            // TODO: after https://jira.techstyle.net/browse/YIT-1473 is merged, remove _Yitty
            name={LoginAsset}
            aspectRatio="auto"
          />
        </LoginAssetSection>
      )}
      <LoginSlidingPanels
        onLoginSuccess={pathname === '/' ? homepageLoginSuccess : undefined}
      />
    </Modal>
  );
};

LoginModal.propTypes = {
  title: PropTypes.string,
};

export default LoginModal;
